import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultStationRedirect } from '@app/core/routing/DefaultStationRedirect';
import { Station } from '@mi-front/core';
import { Switch } from 'react-router-dom';
import { SearchScreenAdapterPage } from './SearchScreenAdapterPage';

export const routeGenerator = {
  list: (station: Station) => `/search/s/${station.slug}`,
};

export function SearchRoutes() {
  return (
    <Switch>
      <AppRoute exact path={`/search/s/:slug`} component={SearchScreenAdapterPage} />

      {/* catch all: redirect to most recent station or first station */}
      <DefaultStationRedirect to={(s) => `/search/s/${s.slug}`} />
    </Switch>
  );
}
